// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__2CF7H","icon":"button_icon__3F3Wb","text":"button_text__2vQXl","round":"button_round__pKY-y"};